import classes from "./Accessibility.module.css";
import { Link } from "react-router-dom";

const AccessibilityEn = () => {
  return (
    <div className={`${classes.privacy}`}>
      <div>
        <h2>SECTION 1</h2>
        <h3>ACCESSIBILITY STATEMENT</h3>
        <p>
          <b>MUNICIPALITY OF PATRAS</b> is committed to making its website:{" "}
          <i>
            <a
              href="https://patra.smartiscity.gr/"
              target="_blank"
              rel="noreferrer"
            >
              patra.smartiscity.gr
            </a>
          </i>
          accessible, in accordance with the provisions of Law 4727/2020
          (Government Gazette 184/A/23-09-2020), Chapter H, "Digital
          Accessibility (Transposition into Greek legislation of Directive (EU)
          2016/2102 of the European Parliament and of the Council of 26 October
          2016 on the accessibility of the websites and mobile applications of
          public sector bodies)," which incorporates Directive (EU) 2016/2102
          into Greek law.
        </p>
        <p>
          This accessibility statement applies to the following website:{" "}
          <i>
            <a
              href="https://patra.smartiscity.gr/"
              target="_blank"
              rel="noreferrer"
            >
              patra.smartiscity.gr
            </a>
          </i>
        </p>

        <h4>Compliance Status</h4>
        <p>
          This website{" "}
          <i>
            <a
              href="https://patra.smartiscity.gr/"
              target="_blank"
              rel="noreferrer"
            >
              patra.smartiscity.gr
            </a>
          </i>
          fully complies with the Web Content Accessibility Guidelines (WCAG 2.1
          Level AA).
        </p>
        <h4>Preparation of this Accessibility Statement</h4>
        <p>This statement was prepared on 21 November 2022.</p>

        <p>
          The actual assessment of the website's compliance with the
          requirements of Directive (EU) 2016/2102 was carried out through
          self-assessment by the public sector body, with the assistance of the
          UserWay Website Accessibility Widget.
        </p>
        <p>Last reviewed on 21 November 2022.</p>

        <h4>Feedback and Contact Information</h4>
        <p>
          In accordance with Article 45 of Law 4727/2020 (Government Gazette
          184/A/23-09-2020), any interested party has the right to submit
          comments, request information regarding the website's compliance
          status, or request information that is missing.
        </p>
        <p>
          At the <b>MUNICIPALITY OF PATRAS</b>, such requests may be submitted
          by email to protodp@patras.gr.
        </p>
        <p>
          The responsible department for accessibility matters and for handling
          requests submitted through the feedback mechanism is:
        </p>
        <h4>
          Directorate of Planning, Organization and Information Technology
        </h4>
        <p>
          e-mail:{" "}
          <a
            href="mailto:pliroforiki@patras.gr "
            target="_blank"
            rel="noreferrer"
          >
            pliroforiki@patras.gr{" "}
          </a>
        </p>
        <h4>Enforcement Procedure</h4>
        <p>
          The competent department of the <b>MUNICIPALITY OF PATRAS</b> will
          respond to the applicant in an appropriate manner.
        </p>
        <p>
          If the response to a request or inquiry is unsatisfactory, the
          interested party has the right to contact the appropriate
          institutional authorities, including by submitting a complaint to the
          Greek Ombudsman (https://www.synigoros.gr).
        </p>
        <h2>SECTION 2</h2>

        <h3>Enabling the Accessibility Menu</h3>

        <p>
          The accessibility menu on{" "}
          <i>
            <a
              href="https://patra.smartiscity.gr/"
              target="_blank"
              rel="noreferrer"
            >
              patra.smartiscity.gr
            </a>
          </i>{" "}
          can be activated by clicking the accessibility menu icon displayed at
          the top of the page. After activating the accessibility menu, please
          allow a few moments for it to load completely.
        </p>
        <p>
          <i>
            <a
              href="https://patra.smartiscity.gr/"
              target="_blank"
              rel="noreferrer"
            >
              patra.smartiscity.gr
            </a>
          </i>{" "}
          is continuously working to improve the accessibility of its website
          because we believe it is our shared moral responsibility to provide
          seamless, accessible, and unrestricted access for all users, including
          people with disabilities.
        </p>
        <p>
          As part of our ongoing commitment to improving accessibility and
          resolving accessibility issues, we regularly scan{" "}
          <i>
            <a
              href="https://patra.smartiscity.gr/"
              target="_blank"
              rel="noreferrer"
            >
              patra.smartiscity.gr
            </a>
          </i>{" "}
          using the UserWay Accessibility Scanner to identify and address
          potential accessibility barriers. Despite our efforts to make all
          pages and content{" "}
          <i class="fas fa-dice-one">
            <a
              href="https://patra.smartiscity.gr/"
              target="_blank"
              rel="noreferrer"
            >
              patra.smartiscity.gr
            </a>
          </i>{" "}
          fully accessible, some content may not yet be fully adapted to the
          highest accessibility standards.
        </p>

        <p style={{ float: "right", fontWeight: 600, marginTop: 20 }}>
          <Link to="/">Back to Home</Link>
        </p>
      </div>
    </div>
  );
};

export default AccessibilityEn;
